import { FunctionComponent, ReactNode } from 'react';
import { motion } from 'framer-motion';

type CardProps = {
  title?: string;
  titleClasses?: string;
  children: ReactNode;
  classes?: string;
};

const Card: FunctionComponent<CardProps> = (props: CardProps) => {
  return (
    <motion.div
      className={`bg-white shadow-2xl shadow-stone  ring-stone relative px-6 pt-10 pb-8 ring-gray-900/5 sm:max-w-lg sm:mx-auto rounded-lg sm:px-10 ${props?.classes}`}
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      exit={{ opacity: 0 }}>
      {props?.title !== '' && <h2 className={props?.titleClasses}>{props?.title}</h2>}
      {props?.children}
    </motion.div>
  );
};

export default Card;
